<div class="loading__container" *ngIf="isLoading$ | async">
    <img width="250" height="250" src="assets/img/loading.gif" alt="a1102_loading">
</div>